@if (project) {
  <vwui-badge
    class="project-status project-status--{{ project.status }}"
    [small]="true"
  >{{ 'PROJECT_STATUS.' + project.status | translate : {tisLabelShort : project.tisLabelShort || project.projectInfo.tisLabelShort} }}</vwui-badge>
}
